export default __webpack_public_path__ + "media/images/get-ready/locations-3a7371ccac0614c066bd3e079df3d86c.png";